module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'OSS Configs',
          href: '#/landing-packages',
          exact: true,
        },
        {
          text: 'Paket Landing Page'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Paket Landing Page")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Daftar Paket ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    staticStyle: {
      "min-height": "none !important"
    },
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.liveClasses), function(card) {
    return _c('v-list-item', {
      key: card.id,
      on: {
        "click": function($event) {
          _vm.selectedRow = card;
          _vm.editliveClass();
        }
      }
    }, [_c('v-list-item-content', {
      staticClass: "pt-4 pb-6 ml-2",
      staticStyle: {
        "max-width": "45px"
      }
    }, [_c('v-list-item-subtitle', [_c('span', {
      staticClass: "roboto-text darkblue--text",
      class: _vm.$vuetify.breakpoint.smAndDown ?
        'font-weight-600' :
        'font-weight-700',
      style: (_vm.$vuetify.breakpoint.smAndDown ?
        'font-size:15px' :
        '')
    }, [_vm._v("\n                                ID\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                            " + _vm._s(card.id) + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "pt-4 pb-6"
    }, [_c('v-list-item-subtitle', [_c('span', {
      staticClass: "roboto-text darkblue--text",
      class: _vm.$vuetify.breakpoint.smAndDown ?
        'font-weight-600' :
        'font-weight-700',
      style: (_vm.$vuetify.breakpoint.smAndDown ?
        'font-size:15px' :
        '')
    }, [_vm._v("\n                                Nama\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                            " + _vm._s(card.category_name) + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "d-flex align-self-center"
    }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)
  })], 2)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1441c449","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/oss_configs/components/landing_package/LandingPackage.vue
// module id = 1912
// module chunks = 1